module.exports = __webpack_public_path__ + "static/img/bg-tr.2af7f782.png";